"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgArchiveOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M3 7.994c-.667 0-1-.333-1-.999V3.998C2 2.666 2.68 2 4.038 2H20c1.333 0 2 .666 2 1.998v2.997c0 .666-.33 1-.993 1H21v11.988c0 1.307-.667 1.973-2 1.998-1.333.025-6 .025-14 0-1.333 0-2-.666-2-1.998V7.994zm1-3.996v1.998h16V3.998H4zm1 3.996v11.99h14V7.993H5v.001zm4 1.999h6c.667 0 1 .333 1 .999 0 .666-.333.999-1 .999H9c-.667 0-1-.333-1-1 0-.665.333-.998 1-.998z' }))); };
exports.default = SvgArchiveOutline;
//# sourceMappingURL=ArchiveOutline.js.map